import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import SEO from './SEO';

const HorizontalSlideRestaurant = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();
  const { t, currentLanguage, changeLanguage } = useTranslation();

  const slides = [
    {
      title: 'Sunsari',
      subtitle: 'Vaasa, Finland',
      bgImage: 'https://customer-assets.emergentagent.com/job_59bc8777-119a-4f82-8c8f-d334b36478e1/artifacts/1xrd0hqh_IMG-20251221-WA0165.jpg',
      action: () => navigate('/table-booking'),
      buttonText: 'Reserve Table'
    },
    {
      title: 'Menu',
      subtitle: 'Made From Scratch',
      bgImage: 'https://customer-assets.emergentagent.com/job_nordic-bistro/artifacts/8a0ucdge_FB_IMG_1761264409854.jpg',
      action: () => navigate('/menu'),
      buttonText: 'View Menu'
    },
    {
      title: 'Kitchen',
      subtitle: 'Traditional Cuisine',
      bgImage: 'https://customer-assets.emergentagent.com/job_nordic-bistro/artifacts/rlzcjanu_FB_IMG_1761264422247.jpg',
      action: () => navigate('/about'),
      buttonText: 'About Us'
    },
    {
      title: 'Catering',
      subtitle: 'Catering Services',
      bgImage: 'https://images.unsplash.com/photo-1555244162-803834f70033?w=1920&q=80',
      action: () => navigate('/catering'),
      buttonText: 'View Catering'
    },
    {
      title: 'Visit Us',
      subtitle: 'Hietasaarenkatu 18',
      bgImage: 'https://customer-assets.emergentagent.com/job_nordic-bistro/artifacts/d3yux6z2_FB_IMG_1759419261154.jpg',
      action: () => navigate('/contact'),
      buttonText: 'Contact'
    }
  ];

  // Touch/Swipe functionality
  const [touchStart, setTouchStart] = React.useState(0);
  const [touchEnd, setTouchEnd] = React.useState(0);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const swipeDistance = touchStart - touchEnd;
    const threshold = 100; // Increased threshold for more control
    
    if (swipeDistance > threshold) {
      // Swipe left - go to next slide ONE at a time
      if (currentSlide < slides.length - 1) {
        setCurrentSlide(currentSlide + 1);
      }
    } else if (swipeDistance < -threshold) {
      // Swipe right - go to previous slide ONE at a time
      if (currentSlide > 0) {
        setCurrentSlide(currentSlide - 1);
      }
    }
    
    // Reset touch positions
    setTouchStart(null);
    setTouchEnd(null);
  };

  return (
    <div 
      style={{ position: 'relative', width: '100vw', height: '100vh', overflow: 'hidden', background: '#000' }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {/* SEO Component */}
      <SEO 
        title="Home | Authentic Nepalese & Indian Restaurant"
        description="Welcome to Sunsari Restaurant in Vaasa! Experience authentic Nepalese and Indian cuisine, weekly lunch specials, and catering services. Tervetuloa Sunsari Ravintolaan Vaasassa! Välkommen till Restaurang Sunsari i Vasa!"
        keywords="Sunsari Vaasa, restaurant Vaasa, ravintola Vaasa, restaurang Vasa, Nepalese food, Indian food, butter chicken, lunch Vaasa, catering Vaasa"
      />
      
      {/* TOP NAVIGATION BAR - IMPROVED */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: 'rgba(26, 26, 26, 0.98)',
        borderBottom: '2px solid #d4af37',
        padding: '0.75rem 1rem'
      }}>
        {/* Top row: Logo, Opening Hours, Call, Language */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '0.5rem'
        }}>
          {/* Logo */}
          <div style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: '1.5rem',
            color: '#d4af37',
            cursor: 'pointer'
          }} onClick={() => setCurrentSlide(0)}>sunsari</div>
          
          {/* Opening Hours + Today */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            fontSize: '0.7rem',
            color: '#d4af37'
          }}>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontWeight: 'bold' }}>{new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}</div>
              <div style={{ opacity: 0.8 }}>
                {(() => {
                  const day = new Date().getDay();
                  if (day === 1) return 'OPEN: 11:00-15:00'; // Monday
                  if (day >= 2 && day <= 4) return 'OPEN: 11:00-21:00'; // Tue-Thu
                  if (day === 5) return 'OPEN: 11:00-22:00'; // Friday
                  if (day === 6) return 'OPEN: 12:00-22:00'; // Saturday
                  return 'À la Carte + Wolt 🚚'; // Sunday
                })()}
              </div>
            </div>
          </div>
          
          {/* Call Button + Language */}
          <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
            <a href="tel:+358403779200" style={{
              background: '#d4af37',
              color: '#1a1a1a',
              padding: '0.5rem 1rem',
              borderRadius: '5px',
              textDecoration: 'none',
              fontSize: '0.7rem',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '0.3rem'
            }}>
              📞 CALL
            </a>
            
            <select value={currentLanguage} onChange={(e) => changeLanguage(e.target.value)} style={{
              background: '#d4af37',
              border: 'none',
              color: '#1a1a1a',
              padding: '0.5rem',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '0.7rem',
              fontWeight: 'bold'
            }}>
              <option value="en">EN</option>
              <option value="fi">FI</option>
              <option value="sv">SV</option>
            </select>
          </div>
        </div>
        
        {/* Bottom row: Menu Links */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center',
          gap: '1.5rem',
          borderTop: '1px solid rgba(212, 175, 55, 0.3)',
          paddingTop: '0.5rem'
        }}>
          <button onClick={() => navigate('/menu')} style={{ background: 'none', border: 'none', color: '#d4af37', cursor: 'pointer', fontSize: '0.7rem', fontFamily: 'Lato, sans-serif', letterSpacing: '0.1em' }}>MENU</button>
          <button onClick={() => navigate('/lunch-menu')} style={{ background: 'none', border: 'none', color: '#d4af37', cursor: 'pointer', fontSize: '0.7rem', fontFamily: 'Lato, sans-serif', letterSpacing: '0.1em' }}>LUNCH</button>
          <button onClick={() => navigate('/about')} style={{ background: 'none', border: 'none', color: '#d4af37', cursor: 'pointer', fontSize: '0.7rem', fontFamily: 'Lato, sans-serif', letterSpacing: '0.1em' }}>ABOUT</button>
          <button onClick={() => navigate('/combine-tables')} style={{ background: 'none', border: 'none', color: '#d4af37', cursor: 'pointer', fontSize: '0.7rem', fontFamily: 'Lato, sans-serif', letterSpacing: '0.1em' }}>RESERVE</button>
          <button onClick={() => navigate('/contact')} style={{ background: 'none', border: 'none', color: '#d4af37', cursor: 'pointer', fontSize: '0.7rem', fontFamily: 'Lato, sans-serif', letterSpacing: '0.1em' }}>CONTACT</button>
        </div>
      </div>

      {/* SLIDES */}
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        {slides.map((slide, index) => (
          <div key={index} style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            transform: `translateX(${(index - currentSlide) * 100}%)`,
            transition: 'transform 1s ease-in-out'
          }}>
            <div style={{
              width: '100%',
              height: '100%',
              backgroundImage: `url(${slide.bgImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }} />
            
            <div style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(to right, rgba(26,26,26,0.7), rgba(26,26,26,0.3), rgba(26,26,26,0.6))'
            }} />
            
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
              zIndex: 10
            }}>
              <p style={{ 
                color: '#d4af37', 
                fontSize: '0.9rem', 
                letterSpacing: '0.3em', 
                marginBottom: '1rem', 
                textTransform: 'uppercase',
                background: 'rgba(26, 26, 26, 0.7)',
                padding: '0.5rem 1.5rem',
                borderRadius: '20px',
                display: 'inline-block'
              }}>{slide.subtitle}</p>
              <h1 style={{ color: '#fff', fontSize: '4rem', fontFamily: 'Playfair Display, serif', fontWeight: '300', marginBottom: '2rem', textShadow: '0 4px 20px rgba(0,0,0,0.8)' }}>{slide.title}</h1>
              <div style={{ width: '80px', height: '2px', background: '#d4af37', margin: '0 auto 2rem' }} />
              <button onClick={slide.action} style={{
                padding: '1rem 2.5rem',
                fontSize: '0.875rem',
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
                border: '2px solid #d4af37',
                background: 'rgba(26, 26, 26, 0.5)',
                color: '#d4af37',
                cursor: 'pointer',
                fontFamily: 'Lato, sans-serif',
                transition: 'all 0.3s'
              }}>{slide.buttonText}</button>
            </div>
            
            <div style={{ position: 'absolute', bottom: '2rem', left: '2rem', color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem' }}>
              <span style={{ color: '#d4af37', fontSize: '2rem' }}>{String(index + 1).padStart(2, '0')}</span> / {String(slides.length).padStart(2, '0')}
            </div>
          </div>
        ))}
      </div>

      {/* LEFT ARROW - Visible but not blocking */}
      {currentSlide > 0 && (
        <button 
          onClick={() => setCurrentSlide(currentSlide - 1)}
          style={{
            position: 'absolute',
            left: '1.5rem',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 999,
            width: '45px',
            height: '45px',
            borderRadius: '50%',
            border: '2px solid #d4af37',
            background: 'rgba(212, 175, 55, 0.8)',
            color: '#1a1a1a',
            fontSize: '1.8rem',
            fontWeight: '700',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s',
            boxShadow: '0 2px 10px rgba(212, 175, 55, 0.5)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-50%) scale(1.15)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(212, 175, 55, 0.8)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 10px rgba(212, 175, 55, 0.5)';
          }}
        >
          ←
        </button>
      )}

      {/* RIGHT ARROW - Visible but not blocking */}
      {currentSlide < slides.length - 1 && (
        <button 
          onClick={() => setCurrentSlide(currentSlide + 1)}
          style={{
            position: 'absolute',
            right: '1.5rem',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 999,
            width: '45px',
            height: '45px',
            borderRadius: '50%',
            border: '2px solid #d4af37',
            background: 'rgba(212, 175, 55, 0.8)',
            color: '#1a1a1a',
            fontSize: '1.8rem',
            fontWeight: '700',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s',
            boxShadow: '0 2px 10px rgba(212, 175, 55, 0.5)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-50%) scale(1.15)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(212, 175, 55, 0.8)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 10px rgba(212, 175, 55, 0.5)';
          }}
        >
          →
        </button>
      )}

      {/* PROGRESS DOTS - SMALL */}
      <div style={{
        position: 'absolute',
        bottom: '1.5rem',
        right: '1.5rem',
        zIndex: 999,
        display: 'flex',
        gap: '0.5rem',
        background: 'rgba(26, 26, 26, 0.7)',
        padding: '0.5rem 0.75rem',
        borderRadius: '30px',
        border: '1px solid rgba(212, 175, 55, 0.5)'
      }}>
        {slides.map((_, i) => (
          <button key={i} onClick={() => setCurrentSlide(i)} style={{
            width: currentSlide === i ? '30px' : '8px',
            height: '8px',
            borderRadius: '5px',
            border: '1px solid #d4af37',
            background: currentSlide === i ? '#d4af37' : 'transparent',
            cursor: 'pointer',
            padding: 0,
            transition: 'all 0.3s'
          }} />
        ))}
      </div>
    </div>
  );
};

export default HorizontalSlideRestaurant;